var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDraftProgramIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 155,
    height: 149,
    viewBox: "0 0 155 149",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 154.29,
    height: 149,
    rx: 74.5,
    fill: "#ff6633"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49 55.7906C49 53.8575 50.567 52.2905 52.5 52.2905H74.7685C76.7015 52.2905 78.2685 53.8575 78.2685 55.7906C78.2685 57.7236 76.7015 59.2906 74.7685 59.2906H56V98H94.709V79.2313C94.709 77.2983 96.276 75.7313 98.209 75.7313C100.142 75.7313 101.709 77.2983 101.709 79.2313V101.5C101.709 103.433 100.142 105 98.209 105H52.5C50.567 105 49 103.433 49 101.5V55.7906Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M77 70.0003L98 49.0001L105 56.0002L84 77.0004H77.5C77.2239 77.0004 77 76.7765 77 76.5004V70.0003Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M106.75 54.2501L99.75 47.2501L103.939 43.0607C104.525 42.4749 105.475 42.4749 106.061 43.0607L110.939 47.9394C111.525 48.5252 111.525 49.4749 110.939 50.0607L106.75 54.2501Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDraftProgramIcon);
export default __webpack_public_path__ + "static/media/draft-program-icon.46d5b8bbc87e46611d9c5b3f762e0d0e.svg";
export { ForwardRef as ReactComponent };